import { Controller } from "@hotwired/stimulus"

const DEFAULT_DISMISS_DURATION_IN_SECONDS = 24 * 60 * 60

export default class extends Controller {
  static values = {
    cookieName: String,
    durationInSeconds: {
      type: Number,
      default: DEFAULT_DISMISS_DURATION_IN_SECONDS,
    },
  }

  dismiss() {
    document.cookie = `${this.cookieNameValue}=true; path=/; max-age=${this.durationInSecondsValue}`
  }
}
